'use strict';

var MessageBus = require('./MessageBus.js');
exports.MessageBus = MessageBus;
